import IndexController from '../index_controller'
import { IS_SHOW_ARCHIVED, IS_HIDE_ARCHIVED, trans } from '../../translator'

export default class extends IndexController {
  connect () {
    super.connect()
    this.copyClickHandler = this.copyClickHandler.bind(this)
    document.addEventListener('click', this.copyClickHandler)
  }

  disconnect () {
    document.removeEventListener('click', this.copyClickHandler)
  }

  buildFilters () {
    const filters = super.buildFilters()
    const button = document.getElementById('is-show-archived')

    if (button) {
      const current = button.getAttribute('data-is-show-archived') === '1'
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].is_show_archived = current
    }

    return filters
  }

  filter (event) {
    if (!event.params.lozengeElementId) {
      const button = event.currentTarget
      const current = button.getAttribute('data-is-show-archived') === '1'
      button.setAttribute('data-is-show-archived', current ? '0' : '1')
      button.textContent = !current
        ? trans(IS_HIDE_ARCHIVED, {}, 'filters')
        : trans(IS_SHOW_ARCHIVED, {}, 'filters')
    }
    super.filter(event)
  }

  copyClickHandler (e) {
    const el = e.target.closest('.copy-public-url-key')
    if (!el) {
      return
    }
    e.preventDefault()
    const url = el.getAttribute('data-url')
    if (!url) {
      return
    }
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).catch(() => this.fallbackCopy(url))
    } else {
      this.fallbackCopy(url)
    }
  }

  fallbackCopy (text) {
    const input = document.createElement('textarea')
    input.value = text
    input.style.position = 'fixed'
    input.style.opacity = '0'
    document.body.appendChild(input)
    input.focus()
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
  }
}
